"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var IntegrationHelper = /** @class */ (function () {
    function IntegrationHelper() {
        this.ajaxProvider = (0, AjaxProvider_1.default)("/api");
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    IntegrationHelper.prototype.createAppIntegration = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    IntegrationHelper.prototype.update = function (id, data) {
        return __awaiter(this, void 0, void 0, function () {
            var params, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = { id: id, data: data, previousData: {} };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.ajaxProvider.update("app-integrations", params)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    IntegrationHelper.prototype.runScript = function (id, script) {
        return __awaiter(this, void 0, void 0, function () {
            var params, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = { data: {} };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.ajaxProvider.create("app-integrations/" + id + "/run/" + script, params)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    IntegrationHelper.prototype.hydrate = function (data, integration) {
        if (!integration) {
            return {
                id: data.id,
                template_id: data.template_id,
                version: data.version,
                name: data.name,
                server_id: data.server_id,
                paid_level: data.paid_level,
            };
        }
        else {
            if (data.template_id !== undefined) {
                integration.template_id = data.template_id;
            }
            if (data.version !== undefined) {
                integration.version = data.version;
            }
            if (data.name !== undefined) {
                integration.name = data.name;
            }
            if (data.server_id !== undefined) {
                integration.server_id = data.server_id;
            }
            return integration;
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    IntegrationHelper.prototype.hydrateExtended = function (data, integration) {
        var _a, _b;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var definition = (_a = integration.definition) !== null && _a !== void 0 ? _a : {};
        if (!definition.setup) {
            definition.setup = {
                variables: (_b = data.setup.variables) !== null && _b !== void 0 ? _b : {},
            };
        }
        definition.scripts = {};
        for (var key in data.resources) {
            definition.scripts[key] = data.resources[key];
        }
        integration.definition = definition;
        return integration;
    };
    return IntegrationHelper;
}());
var integrationHelper = new IntegrationHelper();
exports.default = integrationHelper;
